import { API_URL } from "../../../../constants/index";
import { useAuthStore } from "../../../../stores/authStore";
import {
  apiFetch,
  deleteAPI,
  downloadFile,
  getAPI,
  postAPI,
  postMultipartAPI,
  putAPI,
} from "../../../../api/frameworksApi";

export interface OrgUnit {
  id: string;
  name: string;
  shortName?: string;
  description?: string;
  parentId?: string;
  path?: string;
  orgType: string;
  isActive: boolean;
  children?: OrgUnit[];
  createdAt?: string;
  [key: string]: unknown;
}

// export const getAPI = async (apiUrl: string, timeoutMs?: number) => {
//   try {
//     const config =
//       timeoutMs === 0
//         ? { timeout: 0, noTimeout: true }
//         : timeoutMs
//           ? { timeout: timeoutMs }
//           : undefined;
//     const response = await axios.get(apiUrl, config);
//     return response.data;
//   } catch (error: any) {
//     if (error?.isOffline) {
//       throw new Error("OFFLINE");
//     }
//     throw error;
//   }
// };

// export const postAPI = async (apiUrl: string, data: any) => {
//   try {
//     const response = await axios.post(apiUrl, data, {
//       headers: { "Content-Type": "application/json" },
//     });
//     return response.data;
//   } catch (error: any) {
//     if (error?.isOffline) {
//       throw new Error("OFFLINE");
//     }
//     throw error;
//   }
// };

// export const putAPI = async (apiUrl: string, data: any) => {
//   try {
//     const response = await axios.put(apiUrl, data, {
//       headers: { "Content-Type": "application/json" },
//     });
//     return response.data;
//   } catch (error: any) {
//     if (error?.isOffline) {
//       throw new Error("OFFLINE");
//     }
//     throw error;
//   }
// };

// export const deleteAPI = async (apiUrl: string) => {
//   try {
//     const response = await axios.delete(apiUrl);
//     return response.data;
//   } catch (error: any) {
//     if (error?.isOffline) {
//       throw new Error("OFFLINE");
//     }
//     throw error;
//   }
// };

// export const postMultipartAPI = async (apiUrl: string, data: any) => {
//   try {
//     const response = await axios.post(apiUrl, data, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//     return response.data;
//   } catch (error: any) {
//     if (error?.isOffline) {
//       throw new Error("OFFLINE");
//     }
//     throw error;
//   }
// };

// export const downloadFile = async (apiUrl: string, timeoutMs?: number) => {
//   try {
//     return await axios.get(apiUrl, {
//       responseType: "blob",
//       ...(timeoutMs ? { timeout: timeoutMs } : {}),
//     });
//   } catch (error: any) {
//     if (error?.isOffline) {
//       throw new Error("OFFLINE");
//     }
//     throw error;
//   }
// };

export interface CgaValidationRuleListRequest {
  keyword?: string;
  sortByColumn?: string;
  sortingOrder?: string;
}

export const fetchCgaValidationCategories = async (
    page: number = 0,
    size: number = 12,
    body: CgaValidationRuleListRequest = {},
) => {
  return postAPI(`${API_URL.CGA_VALIDATION_RULES}/${page}/${size}`, {
    keyword: "",
    sortByColumn: "",
    sortingOrder: "",
    ...body,
  });
};

export const fetchCgaValidationRules = async (categoryId: string) => {
  return getAPI(
    `${API_URL.CGA_VALIDATION_RULES}/${encodeURIComponent(categoryId)}/rules`,
  );
};

export interface ApiEnvelope<T> {
  status: string;
  apiVersion: string;
  requestId: string;
  timestamp: string;
  data: T;
  pagination: { page: number; pageSize: number; total: number } | null;
  errors: { code: string; message: string }[] | null;
}



export function fetchCgaAccessibleOrgs(
  orgType?: string,
): Promise<ApiEnvelope<OrgUnit[]>> {
  const qs = orgType
    ? `?orgType=${orgType}&flat=true`
    : `?flat=true`;

  return apiFetch<ApiEnvelope<OrgUnit[]>>(`/org-units${qs}`);
}

export interface CgaValidationRulePayload {
  id?: string;
  orgId: string;
  ruleKey?: string;
  title?: string;
  category?: string;
  description?: string;
  changeType?: string;
  weightage?: number;
  status?: string;
  enabled?: boolean;
  rules: {
    id?: string;
    title?: string;
    value?: string;
    severity?: string;
    weightage?: number;
    "controls-mapping"?: any[];
    controls?: any[];
  }[];
}

export const createCgaValidationRule = async (
    body: CgaValidationRulePayload,
) => {
  return postAPI(`${API_URL.CGA_VALIDATION_RULES}/create`, body);
};


export const updateCgaValidationRule = async (
    id: string,
    body: CgaValidationRulePayload,
) => {
  return putAPI(`${API_URL.CGA_VALIDATION_RULES}/update/${id}`, body);
};


export const deleteCgaValidationRule = async (
    target: { categoryId: string } | { ruleId: string },
) => {
  const query =
      "categoryId" in target
          ? `category_id=${encodeURIComponent(target.categoryId)}`
          : `rule_id=${encodeURIComponent(target.ruleId)}`;
  return deleteAPI(`${API_URL.CGA_VALIDATION_RULES}/delete?${query}`);
};


export const fetchCgaChangeTypes = async (): Promise<string[]> => {
  const res = await getAPI(`${API_URL.CGA_VALIDATION_RULES}/change-types`);
  const data = res?.data ?? res;
  return Array.isArray(data) ? data : [];
};

export const fetchCgaSeverities = async (): Promise<string[]> => {
  const res = await getAPI(`${API_URL.CGA_VALIDATION_RULES}/severities`);
  const data = res?.data ?? res;
  return Array.isArray(data) ? data : [];
};

export const importCgaValidationRules = async (file: File, orgId: string) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("orgId", orgId);
  return postMultipartAPI(
      `${API_URL.CGA_VALIDATION_RULES}/import?orgId=${encodeURIComponent(orgId)}`,
      formData,
  );
};


export async function downloadCgaValidationRuleTemplate(
    orgId?: string,
): Promise<void> {
  const token = useAuthStore.getState().getToken();
  const headers: Record<string, string> = token
      ? { Authorization: `Bearer ${token}` }
      : {};
  const query = orgId ? `?orgId=${encodeURIComponent(orgId)}` : "";
  const res = await fetch(
      `${API_URL.CGA_VALIDATION_RULES}/export${query}`,
      { headers },
  );
  if (!res.ok) throw new Error(`Failed to export template (${res.status})`);
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = "validation-rules-template.csv";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export const runCgaVirtuosoIngestion = async (orgUnitId: string) => {
  return postAPI(
    `${API_URL.CGA_INGESTION_VIRTUOSO_RUN}?orgUnitId=${encodeURIComponent(orgUnitId)}`,
    {},
  );
};

export interface ChangeLifecycleCount {
  status: string;
  count: number;
}

export interface ChangeLastFetch {
  org_id: string | null;
  source_system: string | null;
  source_tenant: string | null;
  started_at: string | null;
  finished_at: string | null;
  status: string | null;
  records_fetched: number | null;
  records_saved: number | null;
  records_rejected: number | null;
  error_message: string | null;
}

export interface ChangeLifecycleSummary {
  total: number;
  statuses: ChangeLifecycleCount[];
  last_fetch?: ChangeLastFetch | null;
}

export interface ChangeDecisionCount {
  decision: string;
  count: number;
  share: number;
}

export interface ChangeDecisionSummary {
  total: number;
  decisions: ChangeDecisionCount[];
}

export interface ChangeAssessmentListItem {
  cr_number?: string | null;
  number?: string | null;
  change_number?: string | null;
  cr_no?: string | null;
  crNumber?: string | null;
  cr_id: string;
  lifecycle_status: string;
  type: string;
  category: string;
  application: string;
  target: string;
  ip_address: string;
  start_date: string;
  requested_by: string;
  requested_name?: string | null; 
  decision: string | null;
  score: number | null;
  failed: number | null;
  run_id?: string | null;
  run_status?: "PENDING" | "RUNNING" | "SUCCESS" | "FAILED" | null;
  last_completed_stage?: string | null;
  stopped_at_stage?: string | null;
  stopped_reason?: string | null;
  last_fetched_at?: string | null;
}

export interface ChangeAssessmentListResponse {
  items: ChangeAssessmentListItem[];
  pagination: {
    page: number;
    page_size: number;
    total_items: number;
    total_pages: number;
  };
}

export interface ChangeAssessmentRuleResult {
  rule_id: string;
  rule_name: string;
  description: string;
  review_area: string;
  status: "PASS" | "FAIL" | "WARNING" | "NOT_AVAILABLE" | string;
  severity: string;
  evidence: string;
  finding: string;
  recommendation: string;
  mapped_controls?: {
    framework: string;
    control_id: string;
    control_name: string;
    current_status?: string;
    impact?: string;
    impact_reason?: string;
  }[];
  evaluation_time?: string;
  confidence?: number;
}

export interface ChangeAssessmentRun {
  cr_id: string;
  document_id: string;
  assessed_at: string;
  total_rules: number;
  passed: number;
  failed: number;
  score: number;
  decision: string;
  results: ChangeAssessmentRuleResult[];
}

export interface ChangeHistoryChange {
  label: string;
  item: string | null;
  kind: "added" | "removed" | "modified";
  before: string | null;
  after: string | null;
}

export interface ChangeHistoryDiff {
  previous_synced_at: string;
  added: number;
  removed: number;
  modified: number;
  sections: { section: string; changes: ChangeHistoryChange[] }[];
}

export interface ChangeHistoryPoint {
  index: number;
  synced_at: string;
  actor: { name: string; role: string };
  diff: ChangeHistoryDiff | null;
}

export interface ChangeHistoryResponse {
  cr_id: string;
  sync_interval_minutes: number;
  window_hours: number;
  points: ChangeHistoryPoint[];
}

export interface ChangeFindingsBySeverity {
  total_rules: number;
  passed?: number;
  passed_by_severity?: { severity: string; count: number; share: number }[];
  failed: number;
  failed_by_severity: { severity: string; count: number; share: number }[];
  rules_by_severity: { severity: string; count: number; share: number }[];
  warnings?: number;
  warnings_by_severity?: { severity: string; count: number; share: number }[];
  not_available?: number;
  not_available_by_severity?: { severity: string; count: number; share: number }[];
  pass_rate?: number | null;
}

export interface ChangeReviewAreaRadar {
  areas: { review_area: string; short_label: string; rate: number | null }[];
}

export interface ChangeFindingsByReviewArea {
  total_rules: number;
  failed: number;
  failed_by_area: { review_area: string; count: number; share: number }[];
  rules_by_area: { review_area: string; count: number; share: number }[];
}

export interface ChangeRuleResultsSummary {
  total_rules: number;
  passed: number;
  failed: number;
  warning?: number | null;
  not_available?: number | null;
  pass_share: number;
  fail_share: number;
  warning_share?: number | null;
  not_available_share?: number | null;
  top_failing_area: { review_area: string; failed: number } | null;
}

export interface ChangeReviewAreaPassRateItem {
  warning: number;
  not_available: number;
  id: string;
  review_area: string;
  total: number;
  passed: number;
  failed: number;
  rate: number | null;
}

export interface ChangePassRateByReviewArea {
  total_areas: number;
  clean_areas: number;
  areas: ChangeReviewAreaPassRateItem[];
}

export interface ChangeReviewAreaRule {
  rule_id: string;
  rule_key: string;
  rule_title: string;
  description: string;
  severity: "CRITICAL" | "HIGH" | "MEDIUM" | "LOW" | string;
  status: "PASS" | "FAIL" | "WARNING" | "NOT_AVAILABLE" | string;
  confidence?: number | null;
  evidence?: string | null;
  reasoning?: string | null;
  recommendation?: string | null;
}

export interface ChangeReviewAreaDrilldown {
  id: string;
  review_area: string;
  total: number;
  passed: number;
  failed: number;
  warning: number;
  not_available: number;
  rate: number | null;
  rules: ChangeReviewAreaRule[];
}

export interface ChangeStatusHistoryItem {
  from: string | null;
  to: { code: string; label: string };
  at: string;
  by: string;
  dwell_minutes: number | null;
}

export interface ChangeStatusHistory {
  cr_id: string;
  current_state?: {
    code: string;
    label: string;
    since: string;
    is_final: boolean;
  } | null;
  states: ChangeStatusHistoryItem[];
  history?: ChangeStatusHistoryItem[];
}

export interface ChangeRequestRecord {
  cr_id: string;
  change_number?: string | null;
  source_system: string;
  synced_at: string;
  title: string;
  type: string;
  category: string;
  state: { code: string; label: string } | null;
  application: string;
  target: string;
  ip_address: string;
  requested_by: string;
  targets_count: number;
  approvals_count: number;
  attachments_count: number;
  risk: { rank: string; source_value: number | string; source_label: string } | null;
  impact: { rank: string; source_value: number | string; source_label: string } | null;
  priority: { rank: string; source_value: number | string; source_label: string } | null;
  risk_impact_analysis: string | null;
  environment: string | null;
  change_category: string | null;
  service_availability: { level: string; raw: string } | null;
  approval_status: { code: string; label: string } | null;
  approval_board_required: boolean;
  approval_board_date: string | null;
  targets: {
    ci_ref: string;
    hostname: string;
    ip: string;
    application: { ci_ref: string; code: string; name: string } | null;
  }[];
  approvals: {
    ref: string;
    approver_name: string;
    approver_user_name?: string | null;
    state: string;
    comments: string | null;
    requested_at: string;
    decided_at: string | null;
  }[];
  attachments: {
    ref: string;
    file_name: string;
    content_type: string;
    size_bytes: number;
    uploaded_at: string;
    uploaded_by: string;
    download_link: string;
  }[];
}

export interface ChangeRequestAttachment {
  id?: string;
  crId?: string;
  sourceAttachmentId?: string;
  ref?: string;
  file_name?: string;
  fileName?: string;
  content_type?: string | null;
  fileType?: string | null;
  size_bytes?: number | null;
  fileSize?: number | null;
  uploaded_at?: string | null;
  createdAt?: string | null;
  uploaded_by?: string | null;
  download_link?: string | null;
  extractionStatus?: string | null;
  extractionError?: string | null;
}


export interface ChangeAnalysisTiming {
  cr_id: string;
  change_number: string;
  status: string;
  time_taken: string;
}

export const fetchChangeRequestAttachments = async (
  crId: string,
): Promise<ChangeRequestAttachment[]> => {
  const res = await getAPI(
    `${API_URL.CGA_CHANGE_REQUESTS}/${encodeURIComponent(crId)}/attachments`,
  );
  const data = res?.data ?? res;
  return (Array.isArray(data) ? data : (data?.attachments ?? [])) as
    ChangeRequestAttachment[];
};

export const downloadChangeRequestAttachment = async (
  crId: string,
  attachmentId: string,
  fileName: string,
): Promise<void> => {
  const res = await downloadFile(
    `${API_URL.CGA_CHANGE_REQUESTS}/${encodeURIComponent(crId)}/attachments/${encodeURIComponent(attachmentId)}/download`,
  );
  const url = URL.createObjectURL(res.data as Blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName || "attachment";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const getChangeAssessment = async <T,>(url: string): Promise<T> => {
  const res = await getAPI(url);
  return (res?.data ?? res) as T;
};

export const fetchAnalysisDuration = async (
  crId: string,
): Promise<ChangeAnalysisTiming> => {
  return getChangeAssessment<ChangeAnalysisTiming>(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/timing`,
  );
};

const changeAssessmentQuery = (
  params: Record<string, string | number | undefined>,
): string => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === "") return;
    search.append(key, String(value));
  });
  const query = search.toString();
  return query ? `?${query}` : "";
};

export const fetchChangeLifecycleSummary = async (
  q?: string,
): Promise<ChangeLifecycleSummary> => {
  return getChangeAssessment(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/summary/lifecycle${changeAssessmentQuery({ q })}`,
  );
};

export const fetchChangeDecisionSummary = async (
  q?: string,
): Promise<ChangeDecisionSummary> => {
  return getChangeAssessment(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/summary/decisions${changeAssessmentQuery({ q })}`,
  );
};

export const fetchChangeAssessments = async (
  params: {
    q?: string;
    decision?: string;
    lifecycle_status?: string;
    page?: number;
    page_size?: number;
    sort?: string;
  } = {},
): Promise<ChangeAssessmentListResponse> => {
  return getChangeAssessment(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}${changeAssessmentQuery({
      page: 1,
      page_size: 50,
      sort: "start_date:desc",
      ...params,
    })}`,
  );
};

export const fetchChangeAssessmentRun = async (
  crId: string,
  filters: {
    status?: "PASS" | "FAIL";
    severity?: string;
    review_area?: string;
    q?: string;
  } = {},
): Promise<ChangeAssessmentRun> => {
  return getChangeAssessment(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/assessment${changeAssessmentQuery(filters)}`,
  );
};

export const runCgaChangeAssessment = async (
  runId: string,
): Promise<{ run_id: string; run_status: string; message?: string }> => {
  const res = await postAPI(
    `${API_URL.CGA_VALIDATION_RUNS}/${encodeURIComponent(runId)}/resume`,
    {},
  );
  return (res?.data ?? res) as {
    run_id: string;
    run_status: string;
    message?: string;
  };
};

export const fetchChangeAssessmentHistory = async (
  crId: string,
  range: { from: Date; to: Date },
): Promise<ChangeHistoryResponse> => {
  const res = await postAPI(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/history`,
    {
      from: range.from.toISOString(),
      to: range.to.toISOString(),
    },
  );
  return (res?.data ?? res) as ChangeHistoryResponse;
};

export const fetchChangeFindingsBySeverity = async (
  crId: string,
): Promise<ChangeFindingsBySeverity> => {
  type Bands = ChangeFindingsBySeverity["failed_by_severity"];
  const data = await getChangeAssessment<any>(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/findings/by-severity`,
  );

  const totalRules = data?.total_rules ?? 0;
  
  // Handle new format where failed counts are nested inside "fail"
  const failed = data?.fail?.total ?? data?.failed ?? 0;
  const failedBySeverityRaw = data?.fail?.by_severity ?? data?.failed_by_severity;
  const rulesBySeverityRaw = data?.rules_by_severity;
  
  const warnings = data?.warning?.total ?? 0;
  const warningsBySeverityRaw = data?.warning?.by_severity;
  
  const notAvailable = data?.not_available?.total ?? 0;
  const notAvailableBySeverityRaw = data?.not_available?.by_severity;

  const passed = data?.pass?.total ?? data?.passed ?? 0;
  const passedBySeverityRaw = data?.pass?.by_severity ?? data?.passed_by_severity;
  const passRate = data?.pass_rate !== undefined ? data.pass_rate : null;

  const SEVERITY_LABEL: Record<string, string> = {
    CRITICAL: "Critical",
    HIGH: "High",
    MEDIUM: "Medium",
    LOW: "Low",
    INFO: "Informational",
    INFORMATIONAL: "Informational",
  };

  const toBands = (
    value: Record<string, number> | Bands | undefined,
    base: number,
  ): Bands => {
    if (Array.isArray(value)) return value;
    return Object.entries(value ?? {}).map(([band, count]) => ({
      severity: SEVERITY_LABEL[band.toUpperCase()] ?? band,
      count: (count as number) ?? 0,
      share: base > 0 ? Math.round((((count as number) ?? 0) / base) * 100) : 0,
    }));
  };

  return {
    total_rules: totalRules,
    passed,
    passed_by_severity: toBands(passedBySeverityRaw, passed),
    failed,
    failed_by_severity: toBands(failedBySeverityRaw, failed),
    rules_by_severity: toBands(rulesBySeverityRaw, totalRules),
    warnings,
    warnings_by_severity: toBands(warningsBySeverityRaw, warnings),
    not_available: notAvailable,
    not_available_by_severity: toBands(notAvailableBySeverityRaw, notAvailable),
    pass_rate: passRate,
  };
};

export const fetchChangeReviewAreaRadar = async (
  crId: string,
): Promise<ChangeReviewAreaRadar> => {
  const data = await getChangeAssessment<
    ChangeReviewAreaRadar | ChangeReviewAreaRadar["areas"]
  >(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/review-areas/radar`,
  );
  return Array.isArray(data) ? { areas: data } : (data ?? { areas: [] });
};

export const fetchChangeFindingsByReviewArea = async (
  crId: string,
): Promise<ChangeFindingsByReviewArea> => {
  const data = await getChangeAssessment<{
    total_rules?: number;
    failed?: number;
    failed_by_area?: Record<string, number> | ChangeFindingsByReviewArea["failed_by_area"];
    rules_by_area?: Record<string, number> | ChangeFindingsByReviewArea["rules_by_area"];
  }>(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/findings/by-review-area`,
  );

  const totalRules = data?.total_rules ?? 0;
  const failed = data?.failed ?? 0;

  const toAreas = (
    value: Record<string, number> | ChangeFindingsByReviewArea["failed_by_area"] | undefined,
    base: number,
  ): ChangeFindingsByReviewArea["failed_by_area"] => {
    if (Array.isArray(value)) return value;
    return Object.entries(value ?? {}).map(([review_area, count]) => ({
      review_area,
      count: count ?? 0,
      share: base > 0 ? Math.round(((count ?? 0) / base) * 100) : 0,
    }));
  };

  return {
    total_rules: totalRules,
    failed,
    failed_by_area: toAreas(data?.failed_by_area, failed),
    rules_by_area: toAreas(data?.rules_by_area, totalRules),
  };
};

export const fetchChangeRuleResultsSummary = async (
  crId: string,
): Promise<ChangeRuleResultsSummary> => {
  return getChangeAssessment(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/rule-results`,
  );
};

export const fetchChangePassRateByReviewArea = async (
  crId: string,
): Promise<ChangePassRateByReviewArea> => {
  return getChangeAssessment<ChangePassRateByReviewArea>(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/review-areas/pass-rate`,
  );
};

export const fetchChangeReviewAreaRules = async (
  crId: string,
  categoryId: string,
): Promise<ChangeReviewAreaDrilldown> => {
  return getChangeAssessment<ChangeReviewAreaDrilldown>(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/review-areas/pass-rate?category_id=${encodeURIComponent(categoryId)}`,
  );
};

export const fetchChangeStatusHistory = async (
  crId: string,
): Promise<ChangeStatusHistory> => {
  return getChangeAssessment(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/status-history`,
  );
};



export const CHANGE_ASSESSMENT_SLIDES = {
  findingsBySeverity: "findings-by-severity",
  resultsByReviewArea: "assessment-results-by-review-area",
  findingsByReviewArea: "findings-by-review-area",
  ruleResults: "assessment-rule-results",
  requestSummary: "change-request-summary",
  statusHistory: "change-status-history",
  passRateByReviewArea: "pass-rate-by-review-area",
} as const;

export type ChangeAssessmentSlide =
  (typeof CHANGE_ASSESSMENT_SLIDES)[keyof typeof CHANGE_ASSESSMENT_SLIDES];
export interface ChangeAssessmentSlideFilters {
  status?: "PASS" | "FAIL";
  severity?: string;
  review_area?: string;
  focus?: string;
}

export const fetchChangeAssessmentSlide = async <T,>(
  crId: string,
  slide: ChangeAssessmentSlide,
  filters: ChangeAssessmentSlideFilters = {},
): Promise<T> => {
  const payload = Object.fromEntries(
    Object.entries({ cr_id: crId, ...filters }).filter(
      ([, value]) => value !== undefined && value !== "",
    ),
  );
  const res = await postAPI(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/slide/${slide}`,
    payload,
  );
  return (res?.data ?? res) as T;
};

/* -- Chart drilldown ---------------------------------------------------- */

export type ChangeDrilldownSource =
  | "findings_by_severity"
  | "findings_by_review_area"
  | "review_areas_radar"
  | "review_areas_pass_rate"
  | "rule_results";

export type ChangeDrilldownSeverity =
  | "CRITICAL"
  | "HIGH"
  | "MEDIUM"
  | "LOW"
  | "INFO";

export type ChangeDrilldownStatus =
  | "PASS"
  | "FAIL"
  | "WARNING"
  | "NOT_AVAILABLE";

export interface ChangeDrilldownFilters {
  severity?: ChangeDrilldownSeverity | ChangeDrilldownSeverity[];
  status?: ChangeDrilldownStatus | ChangeDrilldownStatus[];
  review_area?: string | string[];
  keyword?: string;
  page_size?: number;
  pageSize?: number;
}

/** One rule outcome, with the model's own explanation of how it got there. */
export interface ChangeDrilldownItem {
  rule_id: string;
  rule_key: string;
  rule_title: string;
  description: string;
  review_area: string;
  severity: string;
  status: string;
  confidence: number | null;
  evidence: string;
  reasoning: string;
  recommendation: string;
  sources: string[];
  evaluated_at: string;
}

export interface ChangeDrilldownResponse {
  cr_id: string;
  source: ChangeDrilldownSource;
  applied: {
    severity: string | null;
    review_area: string | null;
    status: string | null;
  };
  total: number;
  page: number;
  page_size: number;
  items: ChangeDrilldownItem[];
}

export const CHANGE_DRILLDOWN_PAGE_SIZE = 20;

interface ChangeDrilldownWireItem {
  ruleId?: string;
  rule_id?: string;
  ruleKey?: string;
  rule_key?: string;
  ruleTitle?: string;
  rule_title?: string;
  title?: string;
  name?: string;
  description?: string;
  reviewArea?: string;
  review_area?: string;
  severity?: string;
  status?: string;
  confidence?: number | null;
  evidence?: string;
  reasoning?: string;
  recommendation?: string;
  sources?: string[];
  evaluatedAt?: string;
  evaluated_at?: string;
}

/**
 * Adapter ensuring drilldown items always have standard properties mapped correctly.
 */
const mapDrilldownItem = (
  raw: ChangeDrilldownWireItem,
): ChangeDrilldownItem => ({
  rule_id: raw.rule_id ?? raw.ruleId ?? "",
  rule_key: raw.rule_key ?? raw.ruleKey ?? "",
  rule_title: raw.rule_title ?? raw.ruleTitle ?? raw.title ?? raw.name ?? "",
  description: raw.description ?? "",
  review_area: raw.review_area ?? raw.reviewArea ?? "",
  severity: raw.severity ?? "",
  status: raw.status ?? "",
  confidence: raw.confidence ?? null,
  evidence: raw.evidence ?? "",
  reasoning: raw.reasoning ?? "",
  recommendation: raw.recommendation ?? "",
  sources: Array.isArray(raw.sources) ? raw.sources : [],
  evaluated_at: raw.evaluated_at ?? raw.evaluatedAt ?? "",
});

export const fetchChangeAssessmentDrilldown = async (
  crId: string,
  source: ChangeDrilldownSource,
  filters: ChangeDrilldownFilters = {},
  page = 1,
  pageSize?: number,
): Promise<ChangeDrilldownResponse> => {
  const effectivePageSize =
    (pageSize && pageSize > 0)
      ? pageSize
      : (filters.page_size && filters.page_size > 0)
      ? filters.page_size
      : (filters.pageSize && filters.pageSize > 0)
      ? filters.pageSize
      : CHANGE_DRILLDOWN_PAGE_SIZE;

  const toFilterArray = <T>(val: T | T[] | undefined): T[] | undefined => {
    if (val === undefined || val === null) return undefined;
    return Array.isArray(val) ? val : [val];
  };

  const review_area = toFilterArray(filters.review_area);
  const severity = toFilterArray(filters.severity);
  const status = toFilterArray(filters.status);

  const payload = {
    source,
    ...(review_area && review_area.length > 0 ? { review_area } : {}),
    ...(severity && severity.length > 0 ? { severity } : {}),
    ...(status && status.length > 0 ? { status } : {}),
    ...(filters.keyword?.trim() ? { keyword: filters.keyword.trim() } : {}),
    page,
    page_size: effectivePageSize,
  };

  const res = await postAPI(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/drilldown`,
    payload,
  );

  const data = (res?.data ?? res) as {
    crId?: string;
    cr_id?: string;
    source?: ChangeDrilldownSource;
    applied?: {
      severity?: string[];
      reviewArea?: string[];
      review_area?: string[];
      status?: string[];
    };
    total?: number;
    unfilteredTotal?: number;
    unfiltered_total?: number;
    page?: number;
    pageSize?: number;
    page_size?: number;
    items?: ChangeDrilldownWireItem[];
  } | null;

  return {
    cr_id: data?.cr_id ?? data?.crId ?? crId,
    source: data?.source ?? source,
    applied: {
      severity: (data?.applied?.severity ?? [])[0] ?? null,
      review_area:
        (data?.applied?.review_area ?? data?.applied?.reviewArea ?? [])[0] ??
        null,
      status: (data?.applied?.status ?? [])[0] ?? null,
    },
    total: data?.total ?? data?.unfiltered_total ?? data?.unfilteredTotal ?? 0,
    page: data?.page ?? page,
    page_size: data?.page_size ?? data?.pageSize ?? effectivePageSize,
    items: Array.isArray(data?.items) ? data.items.map(mapDrilldownItem) : [],
  };
};


export interface ServiceNowImportResult {
  importId?: string;
  importType?: string;
  status?: string;
  totalCrCount?: number;
  succeededCrCount?: number;
  failedCrCount?: number;
  attachmentCount?: number;
  errorSummary?: string;
}

export interface CgaIngestionJobResponse {
  jobId: string;
  orgUnitId: string;
  importType: string;
  status: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'COMPLETED_WITH_ERRORS' | 'FAILED';
  percentage: number;
  currentStage?: string;
  totalCrCount: number;
  completedCrCount: number;
  failedCrCount: number;
  totalFileCount: number;
  processedFileCount: number;
  ocrPagesCompleted: number;
  ocrPagesTotal: number;
  elapsedTimeMs: number;
  errorSummary?: string;
  result?: ServiceNowImportResult;
  createdAt: string;
  completedAt?: string;
}

export const importCgaChangeRequests = async (file: File, orgId: string, fileType: string = "AUTO"): Promise<CgaIngestionJobResponse> => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('orgUnitId', orgId);
  if (fileType) {
    formData.append('fileType', fileType);
  }
  const res = await postMultipartAPI(
      `${API_URL.CGA_INGESTION_SERVICENOW_IMPORT}?orgUnitId=${orgId}&fileType=${fileType}`,
      formData,
  );
  return (res?.data ?? res) as CgaIngestionJobResponse;
};

export const pollCgaIngestionJob = async (jobId: string): Promise<CgaIngestionJobResponse> => {
  const res = await getAPI(`${API_URL.CGA_INGESTION_JOBS}/${encodeURIComponent(jobId)}`);
  return (res?.data ?? res) as CgaIngestionJobResponse;
};


/* -------------------------------------------------------------------------- */
/* CGA control-mapping catalog / group / control pickers                      */
/* -------------------------------------------------------------------------- */

export interface CgaMappingCatalog {
  catalogId: string;
  tenantId: string;
  owningOrgUnitId: string;
  documentId: string;
  catalogName: string;
  documentUuid: string;
  documentType: string;
  oscalVersion: string;
  lifecycleStatus: string;
  catalogType: string;
  technologyVerified: boolean;
  owningOrgPath: string;
  catalogDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  versionNumber: number;
  documentOwningOrgUnitId: string;
  documentDeleted: boolean;
  documentCreatedAt: string;
  documentUpdatedAt: string;
}

export interface CgaMappingGroup {
  groupId: string;
  catalogId: string;
  tenantId: string;
  groupCode: string;
  groupTitle: string;
  sortOrder: number;
  groupDeleted: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CgaMappingControl {
  controlId: string;
  catalogId: string;
  tenantId: string;
  groupId: string;
  groupTitle: string;
  catalogName: string;
  controlNumber: string;
  title: string;
  sortOrder: number;
  controlDeleted: boolean;
  createdAt: string;
  updatedAt: string;
  documentId: string;
  documentUuid: string;
  documentType: string;
  oscalVersion: string;
  lifecycleStatus: string;
  catalogVersionNumber: number;
}


const cgaListData = <T,>(res: unknown): T[] => {
  const body = (res as { data?: unknown } | null)?.data ?? res;
  if (Array.isArray(body)) return body as T[];
  if (body && typeof body === "object") {
    const o = body as Record<string, unknown>;
    if (Array.isArray(o.items)) return o.items as T[];
    if (Array.isArray(o.content)) return o.content as T[];
    if (Array.isArray(o.records)) return o.records as T[];
    if (Array.isArray(o.controls)) return o.controls as T[];
  }
  return [];
};

export interface CgaListCatalogsPayload {
  ids?: string[];
  query?: string;
}

export interface CgaListGroupsPayload {
  ids?: string[];
  catalogId?: string;
  query?: string;
}

export interface CgaListControlsPayload {
  ids?: string[];
  catalogId?: string;
  groupId?: string;
  query?: string;
}

export interface CgaRuleMappedControl {
  controlId: string;
  controlNumber: string;
  title: string;
  catalogId?: string;
  catalogTitle?: string;
  catalogName?: string;
  groupId?: string;
  groupTitle?: string;
}

export interface CgaRuleControlsResponse {
  ruleId: string;
  controls: CgaRuleMappedControl[];
}

export interface CgaMapControlPayload {
  catalogId: string;
  groupId: string;
  controlId: string;
}

export const fetchCgaMappingCatalogs = async (
  payload?: CgaListCatalogsPayload,
): Promise<CgaMappingCatalog[]> => {
  const res = await postAPI(`${API_URL.CGA_CONTROL_MAPPING}/catalogs`, payload ?? {});
  return cgaListData<CgaMappingCatalog>(res);
};

export const fetchCgaMappingGroups = async (
  catalogIdsOrPayload: string[] | CgaListGroupsPayload,
): Promise<CgaMappingGroup[]> => {
  let body: CgaListGroupsPayload = {};
  if (Array.isArray(catalogIdsOrPayload)) {
    if (catalogIdsOrPayload.length === 0) return [];
    body = {
      ids: catalogIdsOrPayload,
      ...(catalogIdsOrPayload.length === 1 ? { catalogId: catalogIdsOrPayload[0] } : {}),
    };
  } else if (catalogIdsOrPayload) {
    body = catalogIdsOrPayload;
  }
  const res = await postAPI(`${API_URL.CGA_CONTROL_MAPPING}/groups`, body);
  return cgaListData<CgaMappingGroup>(res);
};

export const fetchCgaMappingControls = async (
  catalogIdsOrPayload: string[] | CgaListControlsPayload,
  groupIds?: string[],
): Promise<CgaMappingControl[]> => {
  let body: CgaListControlsPayload = {};
  if (Array.isArray(catalogIdsOrPayload)) {
    if (!groupIds?.length) return [];
    body = {
      ids: groupIds,
      ...(catalogIdsOrPayload.length === 1 ? { catalogId: catalogIdsOrPayload[0] } : {}),
      ...(groupIds.length === 1 ? { groupId: groupIds[0] } : {}),
    };
  } else if (catalogIdsOrPayload) {
    body = catalogIdsOrPayload;
  }
  const res = await postAPI(`${API_URL.CGA_CONTROL_MAPPING}/controls`, body);
  return cgaListData<CgaMappingControl>(res);
};

export const fetchCgaRuleControls = async (
  ruleId: string,
): Promise<CgaRuleMappedControl[]> => {
  if (!ruleId) return [];
  const res = await getAPI(
    `${API_URL.CGA_CONTROL_MAPPING}/validation-rules/${encodeURIComponent(ruleId)}/controls`,
  );
  const data = (res as any)?.data ?? res;
  if (Array.isArray(data?.controls)) return data.controls;
  if (Array.isArray(data)) return data;
  return [];
};

export const mapCgaRuleControl = async (
  ruleId: string,
  payload: CgaMapControlPayload,
) => {
  return postAPI(
    `${API_URL.CGA_CONTROL_MAPPING}/validation-rules/${encodeURIComponent(ruleId)}/controls`,
    payload,
  );
};

/* -------------------------------------------------------------------------- */
/* CGA dashboard impact (rule-level impact per review area)                    */
/* -------------------------------------------------------------------------- */

export interface CgaImpactControl {
  catalogId: string;
  catalogTitle: string;
  groupId: string;
  groupTitle: string;
  controlId: string;
  controlNumber: string;
  controlTitle: string;
  currentControlStatus: string;
  impactStatus: string;
}

export interface CgaImpactRule {
  ruleId: string;
  ruleTitle: string;
  ruleStatus: string;
  severity: string;
  reason: string;
  controls: CgaImpactControl[];
}

export interface CgaImpactSummary {
  totalRules: number;
  passedRules: number;
  failedRules: number;
  warningRules: number;
  impactedControls: number;
  atRiskControls: number;
  breachedControls: number;
}

export interface CgaImpactData {
  assessmentId: string;
  summary: CgaImpactSummary;
  ruleImpacts: CgaImpactRule[];
}

export interface CgaImpactResponse {
  success: boolean;
  data: CgaImpactData;
  message: string;
}

export const fetchCgaImpact = async (
  crId: string,
  categoryId: string,
): Promise<CgaImpactResponse> => {
  return getAPI(
    `${API_URL.CGA_IMPACT}?crId=${encodeURIComponent(crId)}&categoryId=${encodeURIComponent(categoryId)}`,
  );
};


/* -------------------------------------------------------------------------- */
/* CGA change-assessment dependencies (CR prerequisites)                       */
/* -------------------------------------------------------------------------- */

export interface CgaDependencyTarget {
  ciRef: string;
  hostname: string;
  ip: string;
  applicationName: string;
}

export interface CgaDependencySourceStatus {
  code: string;
  label: string;
  lifecycle: string;
}

export interface CgaDependencySchedule {
  plannedStart: string;
  plannedEnd: string;
}

export interface CgaDependencyEvidence {
  evidenceId: string;
  currentChunkId: string;
  currentContent: string;
  previousChunkId: string;
  similarityDistance: number;
  prerequisiteContent: string;
}

export type CgaDependencyType = "HARD_BLOCKER" | "SOFT_DEPENDENCY" | "CONSUMER";
export type CgaDependencyStatus = "BLOCKING" | "NON_BLOCKING" | "WAITING" | "SATISFIED";

export interface CgaDependencyPrerequisite {
  changeRequestId: string;
  changeNumber: string;
  sourceSystem: string;
  stateCode: string;
  stateLabel: string;
  type: CgaDependencyType;
  dependencyStatus: CgaDependencyStatus;
  title: string;
  sourceStatus: CgaDependencySourceStatus;
  target: string;
  targets: CgaDependencyTarget[];
  service: string;
  team: string;
  owner: string;
  schedule: CgaDependencySchedule;
  message: string;
  satisfied: boolean;
  confidence: number;
  reasoning: string;
  supportingEvidence: CgaDependencyEvidence[];
  lastCheckedAt: string;
}

export interface CgaDependenciesData {
  changeRequestId: string;
  changeNumber: string;
  status: string;
  message: string;
  analyzedAt: string;
  prerequisites: CgaDependencyPrerequisite[];
}

export interface CgaDependenciesResponse {
  status: string;
  apiVersion: string;
  requestId: string;
  timestamp: string;
  data: CgaDependenciesData;
}

export const fetchCgaDependencies = async (
  crId: string,
): Promise<CgaDependenciesResponse> => {
  return getAPI(
    `${API_URL.CGA_CHANGE_ASSESSMENTS}/${encodeURIComponent(crId)}/dependencies`,
  );
};


/* -------------------------------------------------------------------------- */
/* CGA dashboard recommendation (overall CR recommendation per review area)    */
/* -------------------------------------------------------------------------- */

export interface CgaRecommendationData {
  overallRecommendation: string;
  criticalActions: string[];
  issueSummary: string;
  confidence: number;
}

export interface CgaRecommendationResponse {
  status: string;
  apiVersion: string;
  requestId: string;
  timestamp: string;
  data: CgaRecommendationData;
}

export const fetchCgaRecommendation = async (
  crId: string,
  categoryId: string,
): Promise<CgaRecommendationResponse> => {
  return getAPI(
    `${API_URL.CGA_RECOMMENDATION}?crId=${encodeURIComponent(crId)}&categoryId=${encodeURIComponent(categoryId)}`,
  );
};